import React, { useState } from 'react';
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

// Compents
import Header from '../components/header'
import Footer from '../components/footer'
import ProductFilter from "../components/ProductFilter";
import MakeAppoinment from '../components/make-appoinment';
import useGaspAnimations from '../components/useGsapAnimations'

const accordionData = [
   {
id:1,
title:"Ice Manufacturing",
content:"Powers brine chillers and direct evaporators in block/flake/tube plants for efficient, subcooled ice production."
},
{
id:2,
title:"Cold Storage",
content:"Serves multiple rooms/freezers with pumped ammonia overfeed, minimizing oil return issues over long piping runs."
},
{
id:3,
title:"Food Processing",
content:"Delivers rapid chilling for meat, poultry, and produce via flooded or overfeed evaporators in processing lines."
},
{
id:4,
title:"Dairy & Beverage",
content:"Integrates with glycol chillers or direct systems for precise temperature control in pasteurization and storage."
},
]

function Economizer() {
 
    useGaspAnimations()

 const [openSections, setOpenSections] = useState({ 1: true });

  const toggleSection = (id) => {
    setOpenSections((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    //  var settings = {
    //     dots: true,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     // initialSlide: 0,
    //     autoplay: true,
    //     autoplaySpeed: 2000,
       
    //   };

    
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
{/* <section className="breadcrumb-area">
	<div className="container text-center">
		<h1>Air Purger</h1>
	</div>
</section> */}
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li><a href="services.html">Services</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Air Purger</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start service single area--> */}
<section id="service-single-area">
    <div className="container">
        <div className="row">
         <ProductFilter/>
            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                <div className="service-single-content">
                    {/* <!--Start top content --> */}
                    <div className="row top-content">
                        <div className="col-md-5 col-sm-12 col-xs-12 flex-image-middle bdFadeLeft">
                            {/* <Slider {...settings}>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                            </Slider> */}
                               <img src="assets/images/OurProducts/Economizer.webp" alt="Awesome Image"/>
                        </div>
                        <div className="col-md-7 col-sm-12 col-xs-12">
                            <div className="textholder">
                                <div className="title sec-title">
                                    <h1 className='title-anim'><span>Ammonia Recirculator Package</span></h1>
                                </div>
                                <div className="text">
                                    {/* <span>We Are professional. Reliable and Affortable</span> */}
                                    <p className="top">
                                       Ammonia recirculation packages, also known as liquid overfeed or pumped recirculation systems, continuously pump liquid ammonia from a low-pressure receiver through evaporators at an overfeed ratio (typically 3:1 to 6:1 liquid-to-vapor), ensuring full tube wetting for superior heat transfer compared to dry expansion. Excess liquid separates in a surge drum or accumulator before returning as vapor to the compressor, reducing oil logging risks and enabling efficient operation over long piping runs in large plants. These pre-packaged units include canned pumps, separators, controls, and safety interlocks for seamless integration into industrial refrigeration systems
                                    </p>
                                     <div className="single-sidebar">
                                                <a href="assets/indusref-refpak-brochure.pdf" className='single-pdf'>
                                                    <div className="icon-holder download">
                                                        <span className="flaticon-pdf-file-format-symbol"></span>    
                                                    
                                                    </div>
                                                    <div className="title-holder">
                                                        <h5>Download Here!</h5>    
                                                    </div>
                                                </a>
                                    </div> 
                                    {/* <p>Who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a annoying consequences resultant pleasure.</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!--End top content --> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="border"></div>
                        </div>
                    </div>
                    {/* <!--Start middle content--> */}
                    <div className="row middle-content bdFadeUp">
                        <div className="col-md-12">
                            <div className="text-holder">
                                <div className="title">
                                    <h2>Sub-categories</h2>
                                </div>
                                <div className="text">
                                    {/* <p>Don't spend time and money on beautiful landscaping if you have not taken water and irrigation issues into account first. Installing a sprinkler system, leveling the ground.</p> */}
                                    <ul>
                                        <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/>Low-Temperature Recirculation Operates at −25 °C to −40 °C evaporating temperatures for blast freezers, ice plants (flake/block), and subcooled processes, using high-head pumps and robust separators to handle dense mixtures.</li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/>Medium-Temperature Recirculation Runs at −10 °C to −20 °C for cold storage, food processing chillers, and air units, balancing efficiency with simpler controls for multi-evaporator setups.</li>
<li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/>High-Temperature/Desuperheating Recirculation Focuses on −5 °C to 0 °C for dairy, beverage, and supermarket applications, often with desuperheaters to manage hot gas defrost and compressor protection.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-5">
                             <Slider {...settings}>
                                <img src="assets/images/OurProducts/Ice/01.webp" alt="Awesome Image"/>
                                <img src="assets/images/OurProducts/Ice/02.webp" alt="Awesome Image"/>
                            </Slider>
                        </div> */}
                    </div>
                    {/* <!--End middle content--> */}
                    {/* <!--Start bottom content--> */}
                      <div className="row bottom-content bdFadeRight">
                        <div className="col-md-12">
                            <div className="title">
                                    <h2>Sub-category Descriptions</h2>
                                </div>
                            <div className="accordion-box">
                                {accordionData.map(({ id, title, content }) => (
                                <>
                                 {/* <!--Start single accordion box--> */}
                                <div className="accordion accordion-block" key={id}>
                                    <div className={`accord-btn ${openSections[id] ? 'active' : ''}`} onClick={() => toggleSection(id)}><h4>{title}</h4></div>
                                    {openSections[id] && (
                                    <div className="accord-content collapsed">
                                        <p>
                                        {content}
                                        </p>
                                    </div>
                                    )}
                                </div>
                                 {/* <!--End single accordion box-->  */}
                                </>
                                ))}
                        </div>
                    </div>
                    </div>
                    {/* <!--End bottom content--> */}
                    {/* <!--Start Consultation form--> */}
               
                    {/* <!--End Consultation form--> */}
                </div>
            </div>
      
            
        </div>
    </div>    
</section>
{/* <!--End service single area--> */}
      <MakeAppoinment/>
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Economizer;